import React, { useEffect, useState } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import "./AdminMessages.css";
import AdminNavbar from "./AdminNavbar";

function AdminMessages() {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
  axios
    .get("https://himchatterjee.in/backend/messages.php")
    .then((res) => {
      console.log("Messages response:", res.data); // <-- Yahan dekhein
      setMessages(Array.isArray(res.data) ? res.data : []);
      setLoading(false);
    })
    .catch((err) => {
      setMessages([]);
      setLoading(false);
    });
}, []);

  const columns = [
    {
      name: "Name",
      selector: row => `${row.fname} ${row.lname}`,
      sortable: true,
    },
    {
      name: "Email",
      selector: row => row.email,
      sortable: true,
    },
    {
      name: "Message",
      selector: row => row.message,
      wrap: true,
    },
    {
      name: "Date/Time",
      selector: row => row.Timestamp,
      sortable: true,
    },
  ];

  return (
    <>
    <AdminNavbar />
    <div className="messages-container">
      <h2 className="title">Messages Table</h2>
      <div className="table-wrapper">
        <DataTable
          columns={columns}
          data={messages}
          progressPending={loading}
          noDataComponent="No messages found"
          pagination
          highlightOnHover
          striped
          responsive
        />
      </div>
    </div>
    </>
  );
}

export default AdminMessages;